// Zenyth Color Swatch JavaScript
// Simple and direct variant image switching

// Function to reset all swatches and variant containers
function resetAllSwatches() {
  
    const allSwatches = document.querySelectorAll('.znt-swatch_button');
    const allVariantImages = document.querySelectorAll('.variant-image');
    const allMainImages = document.querySelectorAll('.znt-custom-image:not(.variant-image)');
    
    // Reset all swatches
    allSwatches.forEach(s => {
      s.setAttribute('aria-pressed', 'false');
      s.classList.remove('znt-color-pressed', 'znt-color-hovered', 'znt-color-focused');
    });
    
    // Remove znt-variant-active class from all featured list cards
    const allFeaturedListCards = document.querySelectorAll('.znt-featured-list_card');
    allFeaturedListCards.forEach(card => {
      card.classList.remove('znt-variant-active');
    });
  
    // Also remove from all custom-card wrappers (used by product grids like
    // main-collection and search-results where there is no .znt-featured-list_card
    // ancestor around the card).
    const allCustomCards = document.querySelectorAll('.znt-custom-card');
    allCustomCards.forEach(card => {
      card.classList.remove('znt-variant-active');
    });
  
    // Hide all variant images
    allVariantImages.forEach(img => {
      img.style.display = 'none';
      img.classList.remove('znt--showing');
    });
    
    // Show all main images
    allMainImages.forEach(img => {
      img.style.display = 'block';
    });
    
    // Reset product links
    const productLinks = document.querySelectorAll('.znt-custom-card_product-main-link, .product-main-link');
    productLinks.forEach(link => {
      const productId = link.getAttribute('znt-data-product-id');
      if (productId) {
        const firstSwatch = document.querySelector(`.znt-swatch_button[znt-data-product-id="${productId}"]`);
        if (firstSwatch) {
          const originalUrl = firstSwatch.getAttribute('data-original-url');
          link.href = originalUrl;
        }
      }
    });
  }
  
  // Function to handle swatch clicks
  function handleSwatchClick(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const swatch = event.currentTarget;
    const variantId = swatch.getAttribute('data-variant-id');
    const variantUrl = swatch.getAttribute('data-variant-url');
    const cardWrapper = swatch.closest('.znt-custom-card');
  
    
    if (!cardWrapper) {
      return;
    }
    
    // Find the closest znt-featured-list_card that contains both swatch and variant images
    const featuredListCard = swatch.closest('.znt-featured-list_card');
    
    // Get all swatches in this card
    const allSwatches = cardWrapper.querySelectorAll('.znt-swatch_button');
    const variantImages = cardWrapper.querySelectorAll('.variant-image');
    const mainImages = cardWrapper.querySelectorAll('.znt-custom-image:not(.variant-image)');
    
  
    
    // Unpress all swatches in this card
    allSwatches.forEach(s => {
      s.setAttribute('aria-pressed', 'false');
      s.classList.remove('znt-color-pressed');
    });
    
    // Press this swatch
    swatch.setAttribute('aria-pressed', 'true');
    swatch.classList.add('znt-color-pressed');
    
    // Handle znt-variant-active class on featured list card
    if (featuredListCard) {
      // Remove class from all featured list cards
      const allFeaturedListCards = document.querySelectorAll('.znt-featured-list_card');
      allFeaturedListCards.forEach(card => {
        card.classList.remove('znt-variant-active');
      });
      
      // Add class to the specific featured list card that contains this swatch
      featuredListCard.classList.add('znt-variant-active');
    }
  
    // Also toggle znt-variant-active on the .znt-custom-card wrapper so it works
    // in contexts that don't have a .znt-featured-list_card ancestor (product
    // grids: main-collection, search-results, etc.).
    const allCustomCards = document.querySelectorAll('.znt-custom-card');
    allCustomCards.forEach(card => {
      card.classList.remove('znt-variant-active');
    });
    cardWrapper.classList.add('znt-variant-active');
    
    // Hide all variant images
    variantImages.forEach(img => {
      img.style.display = 'none';
      img.classList.remove('znt--showing');
    });
    
    // Show the target variant image
    const targetImage = cardWrapper.querySelector(`.variant-image[data-variant-id="${variantId}"]`);
    
    if (targetImage) {
      targetImage.style.display = 'block';
      targetImage.classList.add('znt--showing');
      
      // Hide main product images
      mainImages.forEach(img => {
        img.style.display = 'none';
      });
  
    } else {
  
      // Show main images if no variant found
      mainImages.forEach(img => {
        img.style.display = 'block';
      });
    }
    
    // Update product links
    const productLinks = cardWrapper.querySelectorAll('.znt-custom-card_product-main-link, .product-main-link');
    productLinks.forEach(link => {
      link.href = variantUrl;
    });
  }
  
  // Function to initialize all swatches
  function initializeSwatches() {
  
    
    // Find all swatch buttons
    const swatches = document.querySelectorAll('.znt-swatch_button');
  
    
    // Add click listeners to all swatches
    swatches.forEach((swatch, index) => {
      const variantId = swatch.getAttribute('data-variant-id');
  
      
      // Remove any existing listeners
      swatch.removeEventListener('click', handleSwatchClick);
      swatch.removeEventListener('mouseenter', handleSwatchHover);
      swatch.removeEventListener('mouseleave', handleSwatchLeave);
      swatch.removeEventListener('focus', handleSwatchFocus);
      swatch.removeEventListener('blur', handleSwatchBlur);
      
      // Add new click listener
      swatch.addEventListener('click', handleSwatchClick);
      
      // Add hover listeners
      swatch.addEventListener('mouseenter', handleSwatchHover);
      swatch.addEventListener('mouseleave', handleSwatchLeave);
      swatch.addEventListener('focus', handleSwatchFocus);
      swatch.addEventListener('blur', handleSwatchBlur);
      
      // Test if this swatch is already pressed
      if (swatch.classList.contains('znt-color-pressed')) {
  
        // Trigger the click to show the variant image
        setTimeout(() => {
          handleSwatchClick({ 
            preventDefault: () => {}, 
            stopPropagation: () => {}, 
            currentTarget: swatch 
          });
        }, 100);
      }
    });
    
    // Set up ESC key handler
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
  
        resetAllSwatches();
      }
    });
    
    // Set up click outside handler
    document.addEventListener('click', function(event) {
      // Check if the click is outside any swatch or swatch-related elements
      const clickedElement = event.target;
      const isSwatchClick = clickedElement.closest('.znt-swatch_button');
      const isSwatchRelated = clickedElement.closest('.znt-custom-card') || 
                             clickedElement.closest('.znt-featured-list_card') ||
                             clickedElement.closest('.znt-custom-card_variant-images');
      
      // If click is not on a swatch or swatch-related element, reset all swatches
      if (!isSwatchClick && !isSwatchRelated) {
  
        resetAllSwatches();
      }
    });
  }
  
  // Function to handle swatch hover
  function handleSwatchHover(event) {
    const swatch = event.currentTarget;
    swatch.classList.add('znt-color-hovered');
  }
  
  // Function to handle swatch leave
  function handleSwatchLeave(event) {
    const swatch = event.currentTarget;
    swatch.classList.remove('znt-color-hovered');
  }
  
  // Function to handle swatch focus
  function handleSwatchFocus(event) {
    const swatch = event.currentTarget;
    swatch.classList.add('znt-color-focused');
    swatch.classList.add('znt-color-hovered');
  }
  
  // Function to handle swatch blur
  function handleSwatchBlur(event) {
    const swatch = event.currentTarget;
    swatch.classList.remove('znt-color-focused');
    swatch.classList.remove('znt-color-hovered');
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSwatches);
  } else {
    initializeSwatches();
  }
  
  // Also initialize after a short delay to catch any dynamically loaded content
  setTimeout(initializeSwatches, 1000);
  setTimeout(initializeSwatches, 2000);
  
  // Watch for new content being added
  if (!window.zenythSwatchObserver) {
    window.zenythSwatchObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          const hasNewSwatches = Array.from(mutation.addedNodes).some(node => {
            if (node.nodeType === 1) { // Element node
              return node.querySelector && node.querySelector('.znt-swatch_button');
            }
            return false;
          });
          
          if (hasNewSwatches) {
            setTimeout(initializeSwatches, 100);
          }
        }
      });
    });
  
    // Start observing
    window.zenythSwatchObserver.observe(document.body, { childList: true, subtree: true });
  }
  
  // Global functions for testing
  window.testSwatch = function(variantId) {
    
    const swatch = document.querySelector(`.znt-swatch_button[data-variant-id="${variantId}"]`);
    if (swatch) {
      swatch.click();
    }
  };
  
  window.showVariantImage = function(variantId) {
    const cardWrappers = document.querySelectorAll('.znt-custom-card');
    cardWrappers.forEach(cardWrapper => {
      const targetImage = cardWrapper.querySelector(`.variant-image[data-variant-id="${variantId}"]`);
      if (targetImage) {
        targetImage.style.display = 'block';
        targetImage.classList.add('znt--showing');
      }
    });
  };
  
  // Test function to check if everything is working
  window.debugColorSwatches = function() {
    
    const swatches = document.querySelectorAll('.znt-swatch_button');
    const variantImages = document.querySelectorAll('.variant-image');
    const cardWrappers = document.querySelectorAll('.znt-custom-card');
    
  
    
    swatches.forEach((swatch, index) => {
      const variantId = swatch.getAttribute('data-variant-id');
      const isPressed = swatch.classList.contains('znt-color-pressed');
    });
    
    variantImages.forEach((img, index) => {
      const variantId = img.getAttribute('data-variant-id');
      const isVisible = img.style.display !== 'none';
    });
    
  };
  
  
  
  
  (function() {
    'use strict';
    
    class ZenythCardProduct {
      constructor() {
        this.init();
      }
  
      init() {
        this.bindEvents();
        // Wait for DOM to be fully loaded before initializing button states
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => {
            this.initializeButtonStates();
          });
        } else {
          this.initializeButtonStates();
        }
        
        // Also run initialization after a short delay to catch any late-loaded content
        setTimeout(() => {
          this.initializeButtonStates();
        }, 100);
      }
  
      initializeButtonStates() {
        // Use the exact same logic that works when interacting
        const quantityInputs = document.querySelectorAll('.znt-quantity-input');
        
        quantityInputs.forEach(input => {
          const productId = input.dataset.productId;
          if (productId) {
            // Update quantity button states (minus/plus buttons)
            const container = input.closest('.znt-quantity-selector');
            if (container) {
              const button = container.querySelector('.znt-quantity-btn');
              if (button) {
                this.updateQuantityButtonStates(button, input);
              }
            }
            
            // Update aria-label
            this.updateQuantityAriaLabel(input);
            
            // Update add to cart button state
            const addToCartBtn = document.querySelector(`[data-product-id="${productId}"] .znt-add-to-cart-btn`);
            if (addToCartBtn) {
              const quantity = parseInt(input.value) || 0;
              this.updateButtonState(addToCartBtn, quantity);
            }
            
            // Update buy now button state
            const buyNowBtn = document.querySelector(`[data-product-id="${productId}"] .znt-quick-buy-btn`);
            if (buyNowBtn) {
              const quantity = parseInt(input.value) || 0;
              this.updateButtonState(buyNowBtn, quantity);
            }
          }
        });
      }
  
      updateButtonState(button, quantity) {
        const isDisabled = quantity <= 0; // Disable when quantity is 0 or less
        
        button.disabled = isDisabled;
        button.setAttribute('aria-disabled', isDisabled);
        
        if (isDisabled) {
          button.classList.add('disabled');
          if (button.classList.contains('znt-quick-buy-btn')) {
            button.setAttribute('aria-label', 'Please increase quantity to buy now');
          } else {
            button.setAttribute('aria-label', 'Please increase quantity to add to cart');
          }
        } else {
          button.classList.remove('disabled');
          if (button.classList.contains('znt-quick-buy-btn')) {
            button.setAttribute('aria-label', 'Buy now');
          } else {
            button.setAttribute('aria-label', 'Add to cart');
          }
        }
      }
  
      bindEvents() {
        // Check if events are already bound
        if (document.zenythEventsBound) {
          return;
        }
        document.zenythEventsBound = true;
        
        // Quantity selector events
        document.addEventListener('click', (e) => {
          if (e.target.closest('.znt-quantity-btn')) {
            this.handleQuantityChange(e);
          }
        });
  
        // Add to cart button events
        document.addEventListener('click', (e) => {
          if (e.target.closest('.znt-add-to-cart-btn')) {
            this.handleAddToCart(e);
          }
        });
  
        // Quick buy button events
        document.addEventListener('click', (e) => {
          if (e.target.closest('.znt-quick-buy-btn')) {
            this.handleQuickBuy(e);
          }
        });
  
        // Quick view button events
        document.addEventListener('click', (e) => {
          if (e.target.closest('.znt-custom-card_quick-view')) {
            this.handleQuickView(e);
          }
        });
  
        // Quick view close button events
        document.addEventListener('click', (e) => {
          if (e.target.closest('.znt-quick-view-close')) {
            this.handleQuickViewClose(e);
          }
        });
  
        // Listen for cart drawer auto-open events
        document.addEventListener('cart:update', (e) => {
          this.handleCartUpdate(e);
        });
  
        // Backdrop click events
        document.addEventListener('click', (e) => {
          if (e.target.matches('.znt-quick-view-backdrop')) {
            this.handleBackdropClick(e);
          }
        });
  
        // Escape key events
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.handleEscapeKey(e);
          }
        });
  
  
  
        // Quantity input change events
        document.addEventListener('change', (e) => {
          if (e.target.classList.contains('znt-quantity-input')) {
            this.validateQuantity(e.target);
          }
        });
  
        // Quantity input real-time updates
        document.addEventListener('input', (e) => {
          if (e.target.classList.contains('znt-quantity-input')) {
            this.updateQuantityAriaLabel(e.target);
          }
        });
  
        // Hook into existing color swatch functionality
        // Override the existing handleSwatchClick function to also update add to cart button
        if (typeof window.handleSwatchClick !== 'undefined') {
          const originalHandleSwatchClick = window.handleSwatchClick;
          window.handleSwatchClick = (event) => {
            // Call the original function first
            originalHandleSwatchClick(event);
            
            // Then update the add to cart button
            this.handleColorSwatchChange(event);
          };
        } else {
          // If handleSwatchClick doesn't exist globally, listen for aria-pressed changes
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' && 
                  mutation.target.classList && 
                  mutation.target.classList.contains('znt-swatch_button') &&
                  mutation.attributeName === 'aria-pressed' && 
                  mutation.target.getAttribute('aria-pressed') === 'true') {
                this.handleColorSwatchChange({ target: mutation.target });
              }
            });
          });
  
          // Observe all swatch buttons
          document.querySelectorAll('.znt-swatch_button').forEach(button => {
            observer.observe(button, { attributes: true });
          });
        }
  
        // Variant selector change events
        document.addEventListener('change', (e) => {
          if (e.target.classList.contains('znt-variant-select')) {
            this.handleVariantSelectChange(e);
          }
        });
      }
  
      handleCartUpdate(e) {
        console.log('Cart update event received:', e.detail);
        
        // Check if cart drawer should auto-open
        const cartDrawer = document.querySelector('cart-drawer');
        console.log('Cart drawer found:', cartDrawer);
        console.log('Cart drawer has auto-open:', cartDrawer?.hasAttribute('auto-open'));
        
        if (cartDrawer && cartDrawer.hasAttribute('auto-open')) {
          console.log('Attempting to open cart drawer...');
          // Trigger the cart drawer to open
          if (typeof cartDrawer.open === 'function') {
            console.log('Using cartDrawer.open()');
            cartDrawer.open();
          } else if (typeof cartDrawer.showDialog === 'function') {
            console.log('Using cartDrawer.showDialog()');
            cartDrawer.showDialog();
          } else {
            console.log('No open method found on cart drawer');
          }
        }
        
        // Alternative approach: Force open cart drawer after a short delay
        setTimeout(() => {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            console.log('Force opening cart drawer...');
            // Try different methods to open the drawer
            if (cartDrawer.open) {
              cartDrawer.open();
            } else if (cartDrawer.showDialog) {
              cartDrawer.showDialog();
            } else {
              // Try to trigger the button click
              const cartButton = document.querySelector('cart-drawer button[on\\:click="/open"]');
              if (cartButton) {
                console.log('Clicking cart button to open drawer');
                cartButton.click();
              }
            }
          }
        }, 100);
      }
  
      forceOpenCartDrawer() {
        console.log('Force opening cart drawer...');

        // Try multiple approaches to open the cart drawer
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          console.log('Cart drawer found, attempting to open...');

          // Method 1: Try the open method
          if (typeof cartDrawer.open === 'function') {
            console.log('Using cartDrawer.open()');
            cartDrawer.open();
            return;
          }

          // Method 2: Try the showDialog method
          if (typeof cartDrawer.showDialog === 'function') {
            console.log('Using cartDrawer.showDialog()');
            cartDrawer.showDialog();
            return;
          }

          // Method 3: Try to click the cart button
          const cartButton = document.querySelector('cart-drawer button');
          if (cartButton) {
            console.log('Clicking cart button');
            cartButton.click();
            return;
          }
          
          // Method 4: Try to find and click any cart-related button
          const cartButtons = document.querySelectorAll('button[aria-label*="cart"], button[aria-label*="Cart"]');
          if (cartButtons.length > 0) {
            console.log('Clicking cart-related button');
            cartButtons[0].click();
            return;
          }
          
          console.log('No method found to open cart drawer');
        } else {
          console.log('Cart drawer not found');
        }
      }
  
      handleQuantityChange(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const button = e.target.closest('.znt-quantity-btn');
        if (!button) return;
        
        const productId = button.dataset.productId;
        const action = button.dataset.action;
        
        // Find the input using a more flexible selector that matches the actual ID pattern
        const input = document.querySelector(`input[data-product-id="${productId}"].znt-quantity-input`);
        
        if (!input) return;
  
        let currentValue = parseInt(input.value) || 0;
        const min = parseInt(input.min) || 0;
        const max = parseInt(input.max) || 99;
  
        if (action === 'increase') {
          if (currentValue < max) {
            input.value = currentValue + 1;
          }
        } else if (action === 'decrease') {
          if (currentValue > min) {
            input.value = currentValue - 1;
          }
        }
  
        // Update button states
        this.updateQuantityButtonStates(button, input);
        
        // Update aria-label with current quantity
        this.updateQuantityAriaLabel(input);
        
        // Announce quantity change to screen readers
        this.announceQuantityChange(input);
        
        // Update add to cart button state based on new quantity
        const addToCartBtn = document.querySelector(`[data-product-id="${productId}"] .znt-add-to-cart-btn`);
        if (addToCartBtn) {
          const newQuantity = parseInt(input.value) || 0;
          this.updateButtonState(addToCartBtn, newQuantity);
        }
        
        // Update buy now button state based on new quantity
        const buyNowBtn = document.querySelector(`[data-product-id="${productId}"] .znt-quick-buy-btn`);
        if (buyNowBtn) {
          const newQuantity = parseInt(input.value) || 0;
          this.updateButtonState(buyNowBtn, newQuantity);
        }
      }
  
      updateQuantityButtonStates(button, input) {
        const container = button.closest('.znt-quantity-selector');
        const minusBtn = container.querySelector('.znt-quantity-minus');
        const plusBtn = container.querySelector('.znt-quantity-plus');
        const currentValue = parseInt(input.value) || 0;
        const min = parseInt(input.min) || 0;
        const max = parseInt(input.max) || 99;
  
        // Disable minus button when at minimum, plus button when at maximum
        if (minusBtn) minusBtn.disabled = currentValue <= min;
        if (plusBtn) plusBtn.disabled = currentValue >= max;
      }
  
      updateQuantityAriaLabel(input) {
        const currentValue = parseInt(input.value) || 0;
        const quantityText = window.Shopify?.locale?.strings?.['products.card.quantity'] || 'Quantity';
        const itemText = currentValue === 1 ? 'item' : 'items';
        
        input.setAttribute('aria-label', `${quantityText}: ${currentValue} ${itemText}`);
      }
  
      announceQuantityChange(input) {
        const currentValue = parseInt(input.value) || 0;
        const productId = input.dataset.productId;
        
        // Find the live region announcer for this product
        const quantitySelector = input.closest('.znt-quantity-selector');
        if (!quantitySelector) return;
        
        const liveRegion = quantitySelector.querySelector('[role="status"]');
        if (!liveRegion) return;
        
        // Clear any existing announcement
        liveRegion.textContent = '';
        
        // Small delay to ensure screen readers pick up the change
        setTimeout(() => {
          // Announce the new quantity
          const message = `Quantity: ${currentValue}`;
          liveRegion.textContent = message;
          
          // Clear the announcement after 3 seconds
          setTimeout(() => {
            liveRegion.textContent = '';
          }, 3000);
        }, 100);
      }
  
      validateQuantity(input) {
        let value = parseInt(input.value) || 0;
        const min = parseInt(input.min) || 0;
        const max = parseInt(input.max) || 99;
  
        if (value < min) {
          input.value = min;
          value = min;
        } else if (value > max) {
          input.value = max;
          value = max;
        }
  
        // Update button states
        const container = input.closest('.znt-quantity-selector');
        if (container) {
          const button = container.querySelector('.znt-quantity-btn');
          if (button) {
            this.updateQuantityButtonStates(button, input);
          }
        }
        
        // Update aria-label with current quantity
        this.updateQuantityAriaLabel(input);
        
        // Announce quantity change to screen readers
        this.announceQuantityChange(input);
        
        // Update add to cart button state based on new quantity
        const productId = input.dataset.productId;
        if (productId) {
          const addToCartBtn = document.querySelector(`[data-product-id="${productId}"] .znt-add-to-cart-btn`);
          if (addToCartBtn) {
            const newQuantity = parseInt(input.value) || 0;
            this.updateButtonState(addToCartBtn, newQuantity);
          }
          
          // Update buy now button state based on new quantity
          const buyNowBtn = document.querySelector(`[data-product-id="${productId}"] .znt-quick-buy-btn`);
          if (buyNowBtn) {
            const newQuantity = parseInt(input.value) || 0;
            this.updateButtonState(buyNowBtn, newQuantity);
          }
        }
      }
  
      async handleAddToCart(e) {
        e.preventDefault();
        const button = e.target.closest('.znt-add-to-cart-btn');
        
        if (button.disabled) return;
  
        // Store the last clicked button for quantity tracking
        this.lastClickedButton = button;
  
        const productId = button.dataset.productId;
        const variantId = button.dataset.variantId;
        const quantityInput = document.querySelector(`input[data-product-id="${productId}"].znt-quantity-input`);
        const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
  
        // Check if quantity is valid (must be at least 1)
        if (quantity < 1) {
          this.showQuantityError(button, 'Please enter a valid quantity');
          return;
        }
  
        // Debug: Log current variant selection state
        const card = document.querySelector(`[data-product-id="${productId}"]`);
        if (card) {
          const activeColorSwatch = card.querySelector('.znt-swatch_button[aria-pressed="true"]');
          const allSelects = card.querySelectorAll('.znt-variant-select');
          const selectedOptions = {};
          
          if (activeColorSwatch) {
            const selectedColor = activeColorSwatch.querySelector('.znt-swatch_label').textContent.trim();
            selectedOptions['Color'] = selectedColor.split('\n')[0].trim();
          }
          
          allSelects.forEach(select => {
            selectedOptions[select.dataset.optionName] = select.value;
          });
          
          console.log('Current variant selection state:', {
            productId: productId,
            variantId: variantId,
            selectedOptions: selectedOptions,
            activeColorSwatch: activeColorSwatch ? 'Yes' : 'No'
          });
        }
  
        console.log('Adding to cart:', {
          productId: productId,
          variantId: variantId,
          quantity: quantity,
          buttonText: button.querySelector('.znt-btn-text')?.textContent
        });
  
        // Show loading state
        this.showLoadingState(button);
  
        try {
          const response = await this.addToCart(variantId, quantity);
          
          console.log('Add to cart response:', response);
          
          if (response.status) {
            // Error occurred
            console.log('Add to cart error:', response.description);
            this.showError(button, response.description || 'Error adding to cart');
          } else {
            // Success
            console.log('Add to cart success');
            this.showSuccess(button);
            this.updateCart(response);

            // Update cart drawer contents and open it (Dawn native pattern, but tolerant to missing #cart-icon-bubble)
            const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            console.log('[ZNT] Drawer element:', cartDrawer);
            console.log('[ZNT] response.sections:', response.sections);
            if (cartDrawer && response.sections) {
              try {
                // 1) Update #CartDrawer inner HTML from the cart-drawer section
                const drawerSection = response.sections['cart-drawer'];
                const drawerHost = document.getElementById('CartDrawer');
                if (drawerHost && drawerSection) {
                  const parsed = new DOMParser().parseFromString(drawerSection, 'text/html');
                  const newDrawer = parsed.querySelector('#CartDrawer');
                  if (newDrawer) {
                    drawerHost.innerHTML = newDrawer.innerHTML;
                    console.log('[ZNT] Drawer contents updated');
                  }
                }

                // 2) Update #cart-icon-bubble ONLY if it exists (Zenyth header may not have it)
                const bubbleSection = response.sections['cart-icon-bubble'];
                const bubbleHost = document.getElementById('cart-icon-bubble');
                if (bubbleHost && bubbleSection) {
                  const parsed = new DOMParser().parseFromString(bubbleSection, 'text/html');
                  const newBubbleSection = parsed.querySelector('.shopify-section');
                  if (newBubbleSection) {
                    bubbleHost.innerHTML = newBubbleSection.innerHTML;
                    console.log('[ZNT] Cart bubble updated');
                  }
                }

                // 3) Mark drawer not-empty and open
                const drawerInner = cartDrawer.querySelector('.drawer__inner');
                if (drawerInner) drawerInner.classList.remove('is-empty');
                cartDrawer.classList.remove('is-empty');

                if (typeof cartDrawer.open === 'function') {
                  cartDrawer.open();
                  console.log('[ZNT] Drawer opened');
                } else {
                  this.forceOpenCartDrawer();
                }
              } catch (err) {
                console.error('[ZNT] Drawer update threw:', err);
                this.forceOpenCartDrawer();
              }
            } else {
              console.log('[ZNT] No drawer / sections - falling back');
              this.forceOpenCartDrawer();
            }
          }
        } catch (error) {
          console.log('Add to cart exception:', error);
          this.showError(button, 'Error adding to cart');
        } finally {
          this.hideLoadingState(button);
        }
      }
  
      async handleQuickBuy(e) {
        e.preventDefault();
        const button = e.target.closest('.znt-quick-buy-btn');
        
        if (button.disabled) return;
  
        const productId = button.dataset.productId;
        const variantId = button.dataset.variantId;
        const quantityInput = document.querySelector(`input[data-product-id="${productId}"].znt-quantity-input`);
        const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
  
        // Check if quantity is valid (must be at least 1)
        if (quantity < 1) {
          this.showQuantityError(button, 'Please enter a valid quantity');
          return;
        }
  
        console.log('Quick buying:', {
          productId: productId,
          variantId: variantId,
          quantity: quantity
        });
  
        // Show loading state
        this.showLoadingState(button);
  
        try {
          // First, clear the cart
          console.log('Clearing cart first...');
          const clearResponse = await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          });
  
          if (!clearResponse.ok) {
            throw new Error('Failed to clear cart');
          }
  
          console.log('Cart cleared successfully');
  
          // Now add the product and redirect to checkout
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = '/cart/add';
          form.style.display = 'none';
  
          // Add variant ID
          const variantInput = document.createElement('input');
          variantInput.type = 'hidden';
          variantInput.name = 'id';
          variantInput.value = variantId;
          form.appendChild(variantInput);
  
          // Add quantity
          const quantityInputEl = document.createElement('input');
          quantityInputEl.type = 'hidden';
          quantityInputEl.name = 'quantity';
          quantityInputEl.value = quantity;
          form.appendChild(quantityInputEl);
  
          // Add return_to parameter to redirect to checkout
          const returnInput = document.createElement('input');
          returnInput.type = 'hidden';
          returnInput.name = 'return_to';
          returnInput.value = '/checkout';
          form.appendChild(returnInput);
  
          // Submit the form
          document.body.appendChild(form);
          form.submit();
          
          console.log('Quick buy form submitted, redirecting to checkout');
        } catch (error) {
          console.log('Quick buy exception:', error);
          this.showError(button, 'Error processing quick buy');
          this.hideLoadingState(button);
        }
      }
  
      handleQuickView(e) {
        e.preventDefault();
        const button = e.target.closest('.znt-custom-card_quick-view');
        const productId = button.dataset.productId;
        const card = document.querySelector(`[data-product-id="${productId}"].znt--has-quick-view-button`);
        
        if (card) {
          // Store the trigger button for focus management
          card._zenythTriggerButton = button;
          
          // Get product title for ARIA labelling
          const productTitle = card.querySelector('.znt-custom-card_heading a')?.textContent?.trim() || 'Product Quick View';
          
          // Show backdrop
          const backdrop = document.querySelector('.znt-quick-view-backdrop');
          if (backdrop) {
            backdrop.style.display = 'block';
            // Use setTimeout to ensure display: block is applied before adding show class
            setTimeout(() => {
              backdrop.classList.add('show');
            }, 10);
          }
          
          // Add ARIA attributes for accessibility and initialize focus trap
          card.setAttribute('role', 'dialog');
          card.setAttribute('aria-modal', 'true');
          card.setAttribute('aria-label', `${productTitle} - Quick View`);
          this.initializeFocusTrap(card);
          
          card.classList.add('znt--quick-view-opened');
          document.body.classList.add('znt--quick-view-dialog-opened');
          
          // Wait 300ms and focus the close button
          setTimeout(() => {
            const closeButton = card.querySelector('.znt-quick-view-close');
            if (closeButton) {
              closeButton.focus();
            }
          }, 300);
        }
      }
  
      handleQuickViewClose(e) {
        e.preventDefault();
        const button = e.target.closest('.znt-quick-view-close');
        const productId = button.dataset.productId;
        const card = document.querySelector(`[data-product-id="${productId}"].znt--has-quick-view-button`);
        
        if (card) {
          // Remove ARIA attributes and focus trap together
          card.removeAttribute('role');
          card.removeAttribute('aria-modal');
          card.removeAttribute('aria-label');
          this.removeFocusTrap(card);
          
          // Hide backdrop
          const backdrop = document.querySelector('.znt-quick-view-backdrop');
          if (backdrop) {
            backdrop.classList.remove('show');
            // Wait for transition to complete before hiding
            setTimeout(() => {
              backdrop.style.display = 'none';
            }, 300);
          }
          
          card.classList.remove('znt--quick-view-opened');
          document.body.classList.remove('znt--quick-view-dialog-opened');
          
          // Return focus to the trigger button after 300ms
          const triggerButton = card._zenythTriggerButton;
          setTimeout(() => {
            if (triggerButton && typeof triggerButton.focus === 'function') {
              triggerButton.focus();
            }
          }, 300);
        }
      }
  
      handleBackdropClick(e) {
        e.preventDefault();
        // Find the currently opened quick view card
        const openedCard = document.querySelector('.znt--has-quick-view-button.znt--quick-view-opened');
        if (openedCard) {
          const productId = openedCard.dataset.productId;
          const card = document.querySelector(`[data-product-id="${productId}"].znt--has-quick-view-button`);
          
          if (card) {
            // Remove ARIA attributes and focus trap together
            card.removeAttribute('role');
            card.removeAttribute('aria-modal');
            card.removeAttribute('aria-label');
            this.removeFocusTrap(card);
            
            // Hide backdrop
            const backdrop = document.querySelector('.znt-quick-view-backdrop');
            if (backdrop) {
              backdrop.classList.remove('show');
              // Wait for transition to complete before hiding
              setTimeout(() => {
                backdrop.style.display = 'none';
              }, 300);
            }
            
            card.classList.remove('znt--quick-view-opened');
            document.body.classList.remove('znt--quick-view-dialog-opened');
            
            // Return focus to the trigger button after 300ms
            const triggerButton = card._zenythTriggerButton;
            setTimeout(() => {
              if (triggerButton && typeof triggerButton.focus === 'function') {
                triggerButton.focus();
              }
            }, 300);
          }
        }
      }
  
      handleEscapeKey(e) {
        // Find the currently opened quick view card
        const openedCard = document.querySelector('.znt--has-quick-view-button.znt--quick-view-opened');
        if (openedCard) {
          const productId = openedCard.dataset.productId;
          const card = document.querySelector(`[data-product-id="${productId}"].znt--has-quick-view-button`);
          
          if (card) {
            // Remove ARIA attributes and focus trap together
            card.removeAttribute('role');
            card.removeAttribute('aria-modal');
            card.removeAttribute('aria-label');
            this.removeFocusTrap(card);
            
            // Hide backdrop
            const backdrop = document.querySelector('.znt-quick-view-backdrop');
            if (backdrop) {
              backdrop.classList.remove('show');
              // Wait for transition to complete before hiding
              setTimeout(() => {
                backdrop.style.display = 'none';
              }, 300);
            }
            
            card.classList.remove('znt--quick-view-opened');
            document.body.classList.remove('znt--quick-view-dialog-opened');
            
            // Return focus to the trigger button after 300ms
            const triggerButton = card._zenythTriggerButton;
            setTimeout(() => {
              if (triggerButton && typeof triggerButton.focus === 'function') {
                triggerButton.focus();
              }
            }, 300);
          }
        }
      }
  
  
      async addToCart(variantId, quantity) {
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantity);
  
        // Get cart drawer sections for live updates
        const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        let cartItemComponentsSectionIds = [];

        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          cartItemComponentsSectionIds = cartDrawer.getSectionsToRender().map(s => s.id);
          formData.append('sections', cartItemComponentsSectionIds.join(','));
          formData.append('sections_url', window.location.pathname);
        }
  
        // Log the variant being added for debugging
        console.log('Adding variant to cart:', {
          variantId: variantId,
          quantity: quantity,
          sections: cartItemComponentsSectionIds,
          timestamp: new Date().toISOString()
        });
  
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
  
        const result = await response.json();
        
        // If successful, dispatch the CartAddEvent to trigger cart drawer and updates
        if (!result.status) {
          console.log('Dispatching cart:update event with data:', {
            resource: result,
            sourceId: variantId,
            data: {
              source: 'zenyth-card-product',
              itemCount: quantity,
              productId: this.lastClickedButton?.dataset.productId,
              variantId: variantId,
              sections: result.sections
            }
          });
          
          // Try to use the native CartAddEvent if available
          try {
            // Check if we can access the native events
            if (typeof window.CartAddEvent !== 'undefined') {
              const cartAddEvent = new window.CartAddEvent(result, variantId, {
                source: 'zenyth-card-product',
                itemCount: quantity,
                productId: this.lastClickedButton?.dataset.productId,
                variantId: variantId,
                sections: result.sections
              });
              document.dispatchEvent(cartAddEvent);
              console.log('Native CartAddEvent dispatched');
            } else {
              // Fallback to custom event
              const cartUpdateEvent = new CustomEvent('cart:update', {
                detail: {
                  resource: result,
                  sourceId: variantId,
                  data: {
                    source: 'zenyth-card-product',
                    itemCount: quantity,
                    productId: this.lastClickedButton?.dataset.productId,
                    variantId: variantId,
                    sections: result.sections
                  }
                },
                bubbles: true
              });
              document.dispatchEvent(cartUpdateEvent);
              console.log('Custom cart:update event dispatched');
            }
          } catch (error) {
            console.error('Error dispatching cart event:', error);
            // Fallback to custom event
            const cartUpdateEvent = new CustomEvent('cart:update', {
              detail: {
                resource: result,
                sourceId: variantId,
                data: {
                  source: 'zenyth-card-product',
                  itemCount: quantity,
                  productId: this.lastClickedButton?.dataset.productId,
                  variantId: variantId,
                  sections: result.sections
                }
              },
              bubbles: true
            });
            document.dispatchEvent(cartUpdateEvent);
            console.log('Fallback cart:update event dispatched');
          }
        }
  
        return result;
      }
  
      showLoadingState(button) {
        const btnText = button.querySelector('.znt-btn-text');
        const btnLoading = button.querySelector('.znt-btn-loading');
        
        if (btnText) btnText.style.display = 'none';
        if (btnLoading) btnLoading.style.display = 'inline-flex';
        
        button.disabled = true;
      }
  
      hideLoadingState(button) {
        const btnText = button.querySelector('.znt-btn-text');
        const btnLoading = button.querySelector('.znt-btn-loading');
        
        if (btnText) btnText.style.display = 'inline';
        if (btnLoading) btnLoading.style.display = 'none';
        
        button.disabled = false;
      }
  
      showSuccess(button) {
        const originalText = button.querySelector('.znt-btn-text');
        if (originalText) {
          originalText.textContent = 'Added!';
          setTimeout(() => {
            originalText.textContent = 'Add to Cart';
          }, 2000);
        }
        
        // Announce to screen readers
        const productId = button.dataset.productId;
        if (productId) {
          const card = document.querySelector(`[data-product-id="${productId}"]`);
          if (card) {
            const quantitySelector = card.querySelector('.znt-quantity-selector');
            if (quantitySelector) {
              const liveRegion = quantitySelector.querySelector('[role="status"]');
              if (liveRegion) {
                // Clear any existing announcement
                liveRegion.textContent = '';
                
                // Small delay to ensure screen readers pick up the change
                setTimeout(() => {
                  liveRegion.textContent = 'Item added to cart';
                  
                  // Clear the announcement after 3 seconds
                  setTimeout(() => {
                    liveRegion.textContent = '';
                  }, 3000);
                }, 100);
              }
            }
          }
        }
      }
  
      showError(button, message) {
        const originalText = button.querySelector('.znt-btn-text');
        if (originalText) {
          const originalTextContent = originalText.textContent;
          originalText.textContent = 'Error';
          setTimeout(() => {
            originalText.textContent = originalTextContent;
          }, 2000);
        }
      }
  
      showQuantityError(button, message) {
        const originalText = button.querySelector('.znt-btn-text');
        if (originalText) {
          const originalTextContent = originalText.textContent;
          originalText.textContent = 'Quantity Required';
          setTimeout(() => {
            originalText.textContent = originalTextContent;
          }, 2000);
        }
        
        // Also show a more prominent error message above the button
        this.showTemporaryMessage(button, message, 'error');
      }
  
      showTemporaryMessage(button, message, type = 'info') {
        // Remove any existing temporary message
        const existingMessage = button.parentElement.querySelector('.znt-temp-message');
        if (existingMessage) {
          existingMessage.remove();
        }
        
        // Create new message element
        const messageEl = document.createElement('div');
        messageEl.className = `znt-temp-message znt-temp-message--${type}`;
        messageEl.textContent = message;
        messageEl.style.cssText = `
          color: #d82c0d;
          background: #fef7f7;
          border: 1px solid #d82c0d;
          border-radius: 4px;
          padding: 8px 12px;
          margin: 8px 0;
          font-size: 14px;
          text-align: center;
          font-weight: 500;
        `;
        
        // Insert message above the button
        button.parentElement.insertBefore(messageEl, button);
        
        // Remove message after 3 seconds
        setTimeout(() => {
          if (messageEl.parentElement) {
            messageEl.remove();
          }
        }, 3000);
      }
  
      updateCart(cartData) {
        // Calculate the new cart count by adding the quantity we just added
        const currentCartCount = this.getCurrentCartCount();
        const quantityAdded = this.getLastAddedQuantity();
        const newCartCount = currentCartCount + quantityAdded;
        
        // Trigger cart update event with calculated count
        const event = new CustomEvent('cart:updated', {
          detail: { 
            cart: cartData,
            newCount: newCartCount,
            quantityAdded: quantityAdded
          }
        });
        document.dispatchEvent(event);
      }
  
      getCurrentCartCount() {
        // Try the new cart icon structure first (cart-icon class with cart-bubble)
        const cartIcon = document.querySelector('cart-icon');
        if (cartIcon) {
          const cartBubbleCount = cartIcon.querySelector('.cart-bubble__text-count');
          if (cartBubbleCount) {
            const count = parseInt(cartBubbleCount.textContent) || 0;
            return count;
          }
        }
        
        // Fallback to the old structure (cart-count-bubble)
        const bubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
        if (bubble) {
          const count = parseInt(bubble.textContent) || 0;
          return count;
        }
        
        return 0;
      }
  
      getLastAddedQuantity() {
        // Get the quantity from the last clicked add to cart button
        const lastButton = this.lastClickedButton;
        if (lastButton) {
          const productId = lastButton.dataset.productId;
          const quantityInput = document.querySelector(`input[data-product-id="${productId}"].znt-quantity-input`);
          return quantityInput ? parseInt(quantityInput.value) || 1 : 1;
        }
        return 1;
      }
  
      handleColorSwatchChange(e) {
        // Get the swatch button from the event
        const swatchButton = e.currentTarget || e.target.closest('.znt-swatch_button') || e.target;
        if (!swatchButton || !swatchButton.classList.contains('znt-swatch_button')) {
          return;
        }
  
        const productId = swatchButton.dataset.productId || swatchButton.getAttribute('znt-data-product-id');
        const selectedColor = swatchButton.querySelector('.znt-swatch_label').textContent.trim();
        const cleanColor = selectedColor.split('\n')[0].trim();
        
        console.log('Color swatch clicked:', {
          productId: productId,
          selectedColor: cleanColor,
          originalColor: selectedColor
        });
        
        if (!productId) {
          console.log('Missing productId');
          return;
        }
  
        // Get the card and build complete selection state
        const card = document.querySelector(`[data-product-id="${productId}"]`);
        if (!card) return;
  
        const selectedOptions = {};
        
        // Add the selected color
        selectedOptions['Color'] = cleanColor;
        
        // Add all dropdown selections
        const allSelects = card.querySelectorAll('.znt-variant-select');
        allSelects.forEach(selectEl => {
          const optionName = selectEl.dataset.optionName;
          const selectedValue = selectEl.value;
          if (optionName && selectedValue) {
            selectedOptions[optionName] = selectedValue;
          }
        });
        
        console.log('All selected options after color change:', selectedOptions);
        
        // Find the matching variant based on all selected options
        const matchingVariant = this.findMatchingVariantFlexible(productId, selectedOptions);
        
        console.log('Found matching variant after color change:', matchingVariant);
        
                if (matchingVariant) {
            // Update all buttons with the new variant ID
            const buttons = document.querySelectorAll(`[data-product-id="${productId}"].znt-add-to-cart-btn, [data-product-id="${productId}"].znt-quick-buy-btn`);
            
            buttons.forEach(btn => {
              const oldVariantId = btn.dataset.variantId;
              btn.dataset.variantId = matchingVariant.id;
              console.log(`Updated ${btn.className} variant ID after color change:`, {
                from: oldVariantId,
                to: matchingVariant.id,
                available: matchingVariant.available
              });
            });
          } else {
            console.log('No matching variant found after color change');
          }
        
        // Update option availability after color change
        this.updateOptionAvailability(productId);
      }
  
      handleVariantSelectChange(e) {
        const select = e.target;
        const productId = select.dataset.productId;
        const selectedValue = select.value;
        const optionName = select.dataset.optionName;
        
        console.log('Variant dropdown changed:', {
          productId: productId,
          selectedValue: selectedValue,
          optionName: optionName
        });
        
        if (!productId) {
          console.log('Missing productId');
          return;
        }
  
        // Get the card and find all currently selected options
        const card = select.closest('.znt-custom-card');
        const activeColorSwatch = card.querySelector('.znt-swatch_button[aria-pressed="true"]');
        
        console.log('Active color swatch:', activeColorSwatch);
        
        // Build the complete selection state
        const selectedOptions = {};
        
        // Add color if selected
        if (activeColorSwatch) {
          const selectedColor = activeColorSwatch.querySelector('.znt-swatch_label').textContent.trim();
          const cleanColor = selectedColor.split('\n')[0].trim();
          selectedOptions['Color'] = cleanColor;
        }
        
        // Add all dropdown selections
        const allSelects = card.querySelectorAll('.znt-variant-select');
        allSelects.forEach(selectEl => {
          const optionName = selectEl.dataset.optionName;
          const selectedValue = selectEl.value;
          if (optionName && selectedValue) {
            selectedOptions[optionName] = selectedValue;
          }
        });
        
        console.log('All selected options:', selectedOptions);
        
        // Find the matching variant based on all selected options
        const matchingVariant = this.findMatchingVariantFlexible(productId, selectedOptions);
        
        console.log('Found matching variant:', matchingVariant);
        
        // Debug: Show current add to cart button state
        const addToCartBtn = document.querySelector(`[data-product-id="${productId}"].znt-add-to-cart-btn`);
        if (addToCartBtn) {
          console.log('Current add to cart button state:', {
            currentVariantId: addToCartBtn.dataset.variantId,
            buttonText: addToCartBtn.querySelector('.znt-btn-text')?.textContent
          });
        }
        
                if (matchingVariant) {
            // Update all buttons with the new variant ID
            const buttons = document.querySelectorAll(`[data-product-id="${productId}"].znt-add-to-cart-btn, [data-product-id="${productId}"].znt-quick-buy-btn`);
            
            buttons.forEach(btn => {
              const oldVariantId = btn.dataset.variantId;
              btn.dataset.variantId = matchingVariant.id;
              console.log(`Updated ${btn.className} variant ID:`, {
                from: oldVariantId,
                to: matchingVariant.id,
                available: matchingVariant.available
              });
            });
          } else {
            console.log('No matching variant found for selected options');
          }
        
        // Update option availability after dropdown change
        this.updateOptionAvailability(productId);
      }
  
      findVariantByColorAndSize(productId, color, size) {
        // Get all variants for this product from the DOM
        const card = document.querySelector(`[data-product-id="${productId}"]`);
        if (!card) {
          console.log('Card not found');
          return null;
        }
  
        const variantDataContainer = card.querySelector('.znt-variant-data');
        if (!variantDataContainer) {
          console.log('Variant data container not found');
          return null;
        }
  
        // Parse the JSON data from the script tag
        let variantData;
        try {
          variantData = JSON.parse(variantDataContainer.textContent);
        } catch (e) {
          console.error('Failed to parse variant data:', e);
          return null;
        }
  
        const variants = variantData.variants || [];
        console.log('Found', variants.length, 'variants');
        
        // Find the variant that matches both color and size
        for (let variant of variants) {
          const variantId = variant.id;
          const variantAvailable = variant.available;
          const variantOptions = variant.options || [];
          
          console.log('Checking variant:', {
            variantId: variantId,
            variantOptions: variantOptions,
            available: variantAvailable
          });
          
          // Check if this variant matches both color and size
          // Color is typically option 0, size is typically option 1
          if (variantOptions.length >= 2) {
            const variantColor = variantOptions[0];
            const variantSize = variantOptions[1];
            
            console.log('Comparing:', {
              variantColor: variantColor,
              selectedColor: color,
              variantSize: variantSize,
              selectedSize: size
            });
            
            if (variantColor.toLowerCase() === color.toLowerCase() && variantSize === size) {
              console.log('Found exact match!');
              return {
                id: variantId,
                available: variantAvailable
              };
            }
          }
        }
        
        console.log('No exact match found, looking for first available variant');
        
        // If no exact match, return the first available variant
        for (let variant of variants) {
          const variantId = variant.id;
          const variantAvailable = variant.available;
          
          if (variantAvailable) {
            console.log('Returning first available variant:', variantId);
            return {
              id: variantId,
              available: variantAvailable
            };
          }
        }
        
        console.log('No available variants found');
        return null;
      }
  
      findVariantBySizeOnly(productId, size) {
        // Get all variants for this product from the DOM
        const card = document.querySelector(`[data-product-id="${productId}"]`);
        if (!card) {
          console.log('Card not found');
          return null;
        }
  
        const variantDataContainer = card.querySelector('.znt-variant-data');
        if (!variantDataContainer) {
          console.log('Variant data container not found');
          return null;
        }
  
        // Parse the JSON data from the script tag
        let variantData;
        try {
          variantData = JSON.parse(variantDataContainer.textContent);
        } catch (e) {
          console.error('Failed to parse variant data:', e);
          return null;
        }
  
        const variants = variantData.variants || [];
        console.log('Found', variants.length, 'variants for size-only search');
        
        // Find the first available variant with this size
        for (let variant of variants) {
          const variantId = variant.id;
          const variantAvailable = variant.available;
          const variantOptions = variant.options || [];
          
          console.log('Checking variant for size match:', {
            variantId: variantId,
            variantOptions: variantOptions,
            available: variantAvailable
          });
          
          // Check if this variant matches the size
          // Size is typically option 1 (index 1)
          if (variantOptions.length >= 2) {
            const variantSize = variantOptions[1];
            
            console.log('Comparing sizes:', {
              variantSize: variantSize,
              selectedSize: size
            });
            
            if (variantSize === size && variantAvailable) {
              console.log('Found size match!');
              return {
                id: variantId,
                available: variantAvailable
              };
            }
          }
        }
        
        console.log('No size match found, looking for first available variant');
        
        // If no size match, return the first available variant
        for (let variant of variants) {
          const variantId = variant.id;
          const variantAvailable = variant.available;
          
          if (variantAvailable) {
            console.log('Returning first available variant:', variantId);
            return {
              id: variantId,
              available: variantAvailable
            };
          }
        }
        
        console.log('No available variants found');
        return null;
      }
  
      findMatchingVariantFlexible(productId, selectedOptions) {
        // Get all variants for this product from the DOM
        const card = document.querySelector(`[data-product-id="${productId}"]`);
        if (!card) {
          console.log('Card not found for flexible variant search');
          return null;
        }
  
        const variantDataContainer = card.querySelector('.znt-variant-data');
        if (!variantDataContainer) {
          console.log('Variant data container not found for flexible variant search');
          return null;
        }
  
        // Parse the JSON data from the script tag
        let variantData;
        try {
          variantData = JSON.parse(variantDataContainer.textContent);
        } catch (e) {
          console.error('Failed to parse variant data:', e);
          return null;
        }
  
        const variants = variantData.variants || [];
        console.log('Found', variants.length, 'variants for flexible search');
        
        // If no options are selected, return the first available variant
        if (Object.keys(selectedOptions).length === 0) {
          for (let variant of variants) {
            const variantId = variant.id;
            const variantAvailable = variant.available;
            
            if (variantAvailable) {
              console.log('Returning first available variant (no options selected):', variantId);
              return {
                id: variantId,
                available: variantAvailable
              };
            }
          }
          return null;
        }
  
        // Special handling for color-only selection (since you mentioned this works correctly)
        if (Object.keys(selectedOptions).length === 1 && (selectedOptions['Color'] || selectedOptions['Colour'])) {
          const colorValue = selectedOptions['Color'] || selectedOptions['Colour'];
          console.log('Color-only selection detected:', colorValue);
          
          // Find the first available variant with this color
          for (let variant of variants) {
            const variantId = variant.id;
            const variantAvailable = variant.available;
            const variantOptions = variant.options || [];
            
            if (variantAvailable && variantOptions.length > 0) {
              const variantColor = variantOptions[0];
              if (variantColor.toLowerCase() === colorValue.toLowerCase()) {
                console.log('Found color match:', variantId);
                return {
                  id: variantId,
                  available: variantAvailable
                };
              }
            }
          }
        }
        
        // Find the variant that matches all selected options
        for (let variant of variants) {
          const variantId = variant.id;
          const variantAvailable = variant.available;
          const variantOptions = variant.options || [];
          
          console.log('Checking variant for flexible match:', {
            variantId: variantId,
            variantOptions: variantOptions,
            available: variantAvailable
          });
          
          // Check if this variant matches all selected options
          let matches = true;
          let hasMatchingOptions = false;
          
          for (let optionName in selectedOptions) {
            const selectedValue = selectedOptions[optionName];
            const optionIndex = this.getOptionIndexFlexible(productId, optionName);
            
            console.log('Checking option:', {
              optionName: optionName,
              selectedValue: selectedValue,
              optionIndex: optionIndex
            });
            
            if (optionIndex >= 0 && optionIndex < variantOptions.length) {
              hasMatchingOptions = true;
              const variantValue = variantOptions[optionIndex];
              
              console.log('Comparing values:', {
                variantValue: variantValue,
                selectedValue: selectedValue,
                match: variantValue.toLowerCase() === selectedValue.toLowerCase()
              });
              
              if (variantValue.toLowerCase() !== selectedValue.toLowerCase()) {
                matches = false;
                break;
              }
            }
          }
          
          // Only return a match if we actually have matching options and they all match
          if (hasMatchingOptions && matches) {
            console.log('Found exact flexible match!');
            return {
              id: variantId,
              available: variantAvailable
            };
          }
        }
        
        // If no exact match found, try to find a partial match (for cases where not all options are selected)
        for (let variant of variants) {
          const variantId = variant.id;
          const variantAvailable = variant.available;
          const variantOptions = variant.options || [];
          
          let partialMatch = true;
          let hasAnyMatch = false;
          
          for (let optionName in selectedOptions) {
            const selectedValue = selectedOptions[optionName];
            const optionIndex = this.getOptionIndexFlexible(productId, optionName);
            
            if (optionIndex >= 0 && optionIndex < variantOptions.length) {
              hasAnyMatch = true;
              const variantValue = variantOptions[optionIndex];
              
              if (variantValue.toLowerCase() !== selectedValue.toLowerCase()) {
                partialMatch = false;
                break;
              }
            }
          }
          
          // Return the first partial match that's available
          if (hasAnyMatch && partialMatch && variantAvailable) {
            console.log('Found partial flexible match:', variantId);
            return {
              id: variantId,
              available: variantAvailable
            };
          }
        }
        
        // If still no match, return the first available variant
        for (let variant of variants) {
          const variantId = variant.id;
          const variantAvailable = variant.available;
          
          if (variantAvailable) {
            console.log('Returning first available variant as fallback:', variantId);
            return {
              id: variantId,
              available: variantAvailable
            };
          }
        }
        
        console.log('No matching variant found in flexible search');
        return null;
      }
  
      getOptionIndexFlexible(productId, optionName) {
        // Get the option index based on the option name
        const card = document.querySelector(`[data-product-id="${productId}"]`);
        if (!card) return -1;
  
        // Check if this is a color option (handled by swatches)
        if (optionName === 'Color' || optionName === 'Colour') {
          // Color is typically the first option (index 0)
          return 0;
        }
  
        // For other options, check the dropdown selects to determine the index
        const selects = card.querySelectorAll('.znt-variant-select');
        let index = 1; // Start from 1 since color is typically index 0
        
        for (let select of selects) {
          if (select.dataset.optionName === optionName) {
            return index;
          }
          index++;
        }
        
        return -1;
      }
  
      updateOptionAvailability(productId) {
        // Get all variants for this product
        const card = document.querySelector(`[data-product-id="${productId}"]`);
        if (!card) return;
  
        const variantDataContainer = card.querySelector('.znt-variant-data');
        if (!variantDataContainer) return;
  
        // Parse the JSON data from the script tag
        let variantData;
        try {
          variantData = JSON.parse(variantDataContainer.textContent);
        } catch (e) {
          console.error('Failed to parse variant data:', e);
          return;
        }
  
        const variants = variantData.variants || [];
        
        // Get current selections
        const selectedOptions = {};
        
        // Add color if selected
        const activeColorSwatch = card.querySelector('.znt-swatch_button[aria-pressed="true"]');
        if (activeColorSwatch) {
          const selectedColor = activeColorSwatch.querySelector('.znt-swatch_label').textContent.trim();
          const cleanColor = selectedColor.split('\n')[0].trim();
          selectedOptions['Color'] = cleanColor;
        }
        
        // Add all dropdown selections
        const allSelects = card.querySelectorAll('.znt-variant-select');
        allSelects.forEach(selectEl => {
          const optionName = selectEl.dataset.optionName;
          const selectedValue = selectEl.value;
          if (optionName && selectedValue) {
            selectedOptions[optionName] = selectedValue;
          }
        });
  
        console.log('Updating availability for selected options:', selectedOptions);
  
        // Update dropdown availability
        this.updateDropdownAvailability(card, variants, selectedOptions);
        
        // Update color swatch availability
        this.updateColorSwatchAvailability(card, variants, selectedOptions);
      }
  
      updateDropdownAvailability(card, variants, selectedOptions) {
        const selects = card.querySelectorAll('.znt-variant-select');
        
        selects.forEach(select => {
          const optionName = select.dataset.optionName;
          const optionIndex = this.getOptionIndexFlexible(card.dataset.productId, optionName);
          
          if (optionIndex < 0) return;
          
          // Get all available values for this option
          const availableValues = new Set();
          
          variants.forEach(variant => {
            const variantAvailable = variant.available;
            const variantOptions = variant.options || [];
            
            if (variantAvailable && optionIndex < variantOptions.length) {
              // Check if this variant matches all other selected options
              let matchesOtherOptions = true;
              
              for (let otherOptionName in selectedOptions) {
                if (otherOptionName === optionName) continue; // Skip current option
                
                const otherOptionIndex = this.getOptionIndexFlexible(card.dataset.productId, otherOptionName);
                const selectedValue = selectedOptions[otherOptionName];
                
                if (otherOptionIndex >= 0 && otherOptionIndex < variantOptions.length) {
                  if (variantOptions[otherOptionIndex].toLowerCase() !== selectedValue.toLowerCase()) {
                    matchesOtherOptions = false;
                    break;
                  }
                }
              }
              
              if (matchesOtherOptions) {
                availableValues.add(variantOptions[optionIndex]);
              }
            }
          });
          
          // Update option availability
          const options = select.querySelectorAll('option');
          options.forEach(option => {
            const isAvailable = availableValues.has(option.value);
            option.disabled = !isAvailable;
            
            if (!isAvailable && option.selected) {
              // If current selection is unavailable, select first available option
              const firstAvailable = Array.from(options).find(opt => !opt.disabled);
              if (firstAvailable) {
                select.value = firstAvailable.value;
                // Trigger change event
                const event = new Event('change', { bubbles: true });
                select.dispatchEvent(event);
              }
            }
          });
        });
      }
  
      updateColorSwatchAvailability(card, variants, selectedOptions) {
        const swatches = card.querySelectorAll('.znt-swatch_button');
        
        swatches.forEach(swatch => {
          const labelElement = swatch.querySelector('.znt-swatch_label');
          const hiddenElement = labelElement.querySelector('.visually-hidden');
          const originalColor = labelElement.textContent.trim().split('\n')[0].trim();
          const productName = hiddenElement ? hiddenElement.textContent.trim() : '';
          
          // Check if this color is available with current selections
          let isAvailable = false;
          
          variants.forEach(variant => {
            const variantAvailable = variant.available;
            const variantOptions = variant.options || [];
            
            if (variantAvailable && variantOptions.length > 0) {
              const variantColor = variantOptions[0];
              
              if (variantColor.toLowerCase() === originalColor.toLowerCase()) {
                // Check if this variant matches all other selected options
                let matchesOtherOptions = true;
                
                for (let optionName in selectedOptions) {
                  if (optionName === 'Color') continue; // Skip color option
                  
                  const optionIndex = this.getOptionIndexFlexible(card.dataset.productId, optionName);
                  const selectedValue = selectedOptions[optionName];
                  
                  if (optionIndex >= 0 && optionIndex < variantOptions.length) {
                    if (variantOptions[optionIndex].toLowerCase() !== selectedValue.toLowerCase()) {
                      matchesOtherOptions = false;
                      break;
                    }
                  }
                }
                
                if (matchesOtherOptions) {
                  isAvailable = true;
                }
              }
            }
          });
          
          // Update swatch availability
          if (isAvailable) {
            swatch.classList.remove('znt-swatch-unavailable');
            swatch.disabled = false;
            // Remove "(Not Available)" from label if it exists
            const currentText = labelElement.textContent.trim();
            if (currentText.includes('(Not Available)')) {
              labelElement.innerHTML = originalColor + '\n<span class="visually-hidden">' + productName + '</span>';
            }
            // Update aria-label span
            let ariaLabelSpan = swatch.querySelector('.visually-hidden[data-aria-label]');
            if (!ariaLabelSpan) {
              ariaLabelSpan = document.createElement('span');
              ariaLabelSpan.className = 'visually-hidden';
              ariaLabelSpan.setAttribute('data-aria-label', 'true');
              swatch.appendChild(ariaLabelSpan);
            }
            ariaLabelSpan.textContent = `Show ${originalColor} variant of ${productName}`;
          } else {
            swatch.classList.add('znt-swatch-unavailable');
            swatch.disabled = false; // Don't disable the button
            // Add "(Not Available)" to label if it doesn't already have it
            const currentText = labelElement.textContent.trim();
            if (!currentText.includes('(Not Available)')) {
              labelElement.innerHTML = originalColor + ' <span class="znt_availability">(Not Available)</span>\n<span class="visually-hidden">' + productName + '</span>';
            }
            // Update aria-label span
            let ariaLabelSpan = swatch.querySelector('.visually-hidden[data-aria-label]');
            if (!ariaLabelSpan) {
              ariaLabelSpan = document.createElement('span');
              ariaLabelSpan.className = 'visually-hidden';
              ariaLabelSpan.setAttribute('data-aria-label', 'true');
              swatch.appendChild(ariaLabelSpan);
            }
            ariaLabelSpan.textContent = `Show ${originalColor} variant of ${productName} (Not available)`;
          }
        });
      }
  
      // Focus Trap Implementation - Pure JavaScript Solution
      initializeFocusTrap(card) {
        if (!card) return;
        
        // Store reference to the card for cleanup
        this.activeFocusTrapCard = card;
        
        // Create and insert focus trap elements dynamically
        this.createFocusTrapElements(card);
        
        // Set up focus event listeners
        this.setupFocusTrapListeners(card);
        
        // Store the last focused element before trapping
        this.lastFocusedElement = document.activeElement;
      }
  
      createFocusTrapElements(card) {
        // Create start trap element
        const startTrap = document.createElement('div');
        startTrap.className = 'znt-trap_start visually-hidden';
        startTrap.tabIndex = 0;
        startTrap.setAttribute('aria-hidden', 'true');
        
        // Create end trap element
        const endTrap = document.createElement('div');
        endTrap.className = 'znt-trap_end visually-hidden';
        endTrap.tabIndex = 0;
        endTrap.setAttribute('aria-hidden', 'true');
        
        // Insert at the beginning and end of the card
        card.insertBefore(startTrap, card.firstChild);
        card.appendChild(endTrap);
        
        // Store references for cleanup
        card._focusTrapStart = startTrap;
        card._focusTrapEnd = endTrap;
      }
  
      setupFocusTrapListeners(card) {
        const startTrap = card._focusTrapStart;
        const endTrap = card._focusTrapEnd;
        
        if (!startTrap || !endTrap) return;
        
        // When start trap receives focus, move to the first focusable element
        const startTrapHandler = (e) => {
          const firstFocusable = this.getFirstFocusableElement(card);
          if (firstFocusable) {
            firstFocusable.focus();
          }
        };
        
        // When end trap receives focus, move to the last focusable element
        const endTrapHandler = (e) => {
          const lastFocusable = this.getLastFocusableElement(card);
          if (lastFocusable) {
            lastFocusable.focus();
          }
        };
        
        // Add event listeners
        startTrap.addEventListener('focus', startTrapHandler);
        endTrap.addEventListener('focus', endTrapHandler);
        
        // Store handlers for cleanup
        card._focusTrapStartHandler = startTrapHandler;
        card._focusTrapEndHandler = endTrapHandler;
        
        // Also handle Tab key navigation within the dialog
        const keydownHandler = (e) => {
          if (e.key === 'Tab') {
            this.handleTabKeyInDialog(e, card);
          }
        };
        
        card.addEventListener('keydown', keydownHandler);
        card._focusTrapKeydownHandler = keydownHandler;
      }
  
      handleTabKeyInDialog(e, card) {
        const focusableElements = this.getFocusableElements(card);
        if (focusableElements.length === 0) return;
        
        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];
        
        // If shift+tab on first element, go to last
        if (e.shiftKey && document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        }
        // If tab on last element, go to first
        else if (!e.shiftKey && document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
  
      getFocusableElements(container) {
        // Exclude our trap elements from focusable elements
        const focusableSelectors = [
          'button:not([disabled]):not(.znt-trap_start):not(.znt-trap_end)',
          'input:not([disabled]):not([type="hidden"])',
          'select:not([disabled])',
          'textarea:not([disabled])',
          'a[href]:not(.znt-trap_start):not(.znt-trap_end)',
          '[tabindex]:not([tabindex="-1"]):not(.znt-trap_start):not(.znt-trap_end)',
          '[contenteditable="true"]'
        ].join(', ');
        
        const elements = container.querySelectorAll(focusableSelectors);
        
        // Filter out elements that are not visible or are our trap elements
        return Array.from(elements).filter(el => {
          return !el.classList.contains('znt-trap_start') && 
                 !el.classList.contains('znt-trap_end') &&
                 this.isElementVisible(el);
        });
      }
  
      getFirstFocusableElement(container) {
        const focusableElements = this.getFocusableElements(container);
        return focusableElements.length > 0 ? focusableElements[0] : null;
      }
  
      getLastFocusableElement(container) {
        const focusableElements = this.getFocusableElements(container);
        return focusableElements.length > 0 ? focusableElements[focusableElements.length - 1] : null;
      }
  
      isElementVisible(element) {
        const style = window.getComputedStyle(element);
        return style.display !== 'none' && 
               style.visibility !== 'hidden' && 
               style.opacity !== '0' &&
               element.offsetWidth > 0 && 
               element.offsetHeight > 0;
      }
  
      removeFocusTrap(card) {
        if (!card) return;
        
        // Remove trap elements
        if (card._focusTrapStart) {
          if (card._focusTrapStartHandler) {
            card._focusTrapStart.removeEventListener('focus', card._focusTrapStartHandler);
          }
          card._focusTrapStart.remove();
          delete card._focusTrapStart;
          delete card._focusTrapStartHandler;
        }
        
        if (card._focusTrapEnd) {
          if (card._focusTrapEndHandler) {
            card._focusTrapEnd.removeEventListener('focus', card._focusTrapEndHandler);
          }
          card._focusTrapEnd.remove();
          delete card._focusTrapEnd;
          delete card._focusTrapEndHandler;
        }
        
        // Remove keydown handler
        if (card._focusTrapKeydownHandler) {
          card.removeEventListener('keydown', card._focusTrapKeydownHandler);
          delete card._focusTrapKeydownHandler;
        }
        
        // Clear active trap reference
        if (this.activeFocusTrapCard === card) {
          this.activeFocusTrapCard = null;
        }
        
        // Restore focus to the last focused element if it still exists
        if (this.lastFocusedElement && document.contains(this.lastFocusedElement)) {
          try {
            this.lastFocusedElement.focus();
          } catch (e) {
            // Focus restoration failed, that's okay
          }
        }
        
        this.lastFocusedElement = null;
      }
  
  
    }
  
    // Use a global flag to prevent multiple initializations
    if (window.zenythCardProductInitialized) {
      return;
    }
    window.zenythCardProductInitialized = true;
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        new ZenythCardProduct();
      });
    } else {
      new ZenythCardProduct();
    }
  
    // Also initialize for dynamically loaded content
    document.addEventListener('shopify:section:load', () => {
      // Reset the flag for section reloads
      window.zenythCardProductInitialized = false;
      new ZenythCardProduct();
    });
  })();
  
  
  
  // Standalone JS: Updates the cart count bubble in the header after add to cart, simulating a live update without page refresh.
  // This listens for the 'cart:updated' event and updates the DOM accordingly.
  (function() {
    // Prevent multiple event listeners
    if (window.zenythCartCountInitialized) return;
    window.zenythCartCountInitialized = true;
    
    document.addEventListener('cart:updated', function(event) {
      var detail = event.detail;
      if (!detail) return;
      
      var newCount = detail.newCount || 0;
      
      // Try to update the new cart icon structure first (cart-icon class with cart-bubble)
      var cartIcon = document.querySelector('cart-icon');
      if (cartIcon) {
        var cartBubbleCount = cartIcon.querySelector('.cart-bubble__text-count');
        var cartBubbleText = cartIcon.querySelector('.cart-bubble__text .visually-hidden');
        
        if (cartBubbleCount) {
          cartBubbleCount.textContent = newCount;
        }
        
        if (cartBubbleText) {
          cartBubbleText.textContent = 'Total items in cart: ' + newCount;
        }
        
        // Show/hide the bubble based on count
        var cartBubble = cartIcon.querySelector('.cart-bubble');
        if (cartBubble) {
          if (newCount > 0) {
            cartBubble.classList.remove('visually-hidden');
            cartIcon.classList.add('header-actions__cart-icon--has-cart');
          } else {
            cartBubble.classList.add('visually-hidden');
            cartIcon.classList.remove('header-actions__cart-icon--has-cart');
          }
        }
        
        return; // Exit early if we successfully updated the new structure
      }
      
      // Fallback to the old structure (cart-count-bubble)
      var oldCartIcon = document.querySelector('#cart-icon-bubble');
      if (!oldCartIcon) return;
      
      // Check if cart-count-bubble exists
      var bubbleContainer = oldCartIcon.querySelector('.cart-count-bubble');
      
      if (!bubbleContainer) {
        // Create the bubble container if it doesn't exist
        bubbleContainer = document.createElement('div');
        bubbleContainer.className = 'cart-count-bubble';
        oldCartIcon.appendChild(bubbleContainer);
      }
      
      // Check if the spans exist, create them if they don't
      var bubble = bubbleContainer.querySelector('span[aria-hidden="true"]');
      var bubbleVis = bubbleContainer.querySelector('.visually-hidden');
      
      if (!bubble) {
        bubble = document.createElement('span');
        bubble.setAttribute('aria-hidden', 'true');
        bubbleContainer.appendChild(bubble);
      }
      
      if (!bubbleVis) {
        bubbleVis = document.createElement('span');
        bubbleVis.className = 'visually-hidden';
        bubbleContainer.appendChild(bubbleVis);
      }
      
      // Update the count
      bubble.textContent = newCount;
      bubbleVis.textContent = newCount + ' items';
      
      // Show/hide the bubble based on count
      if (newCount > 0) {
        bubbleContainer.style.display = 'block';
      } else {
        bubbleContainer.style.display = 'none';
      }
    });
  })();